module.exports = __webpack_public_path__ + "static/media/05.68cf6d7f.jpg";